import {
  getBreadcrumb,
  getFAQ,
  getHowTo,
  getStructuredDataSchema,
  getWebpage,
} from '@jusbrasil-web/shared-utils-seo'

import { BlogHeadProps } from './blog-head'

export const getStructuredData = ({
  canonicalUrl,
  description,
  faqItems,
  blogLabel,
  howTo,
}: Omit<BlogHeadProps, 'imageAlternativeText' | 'keywords' | 'title'>) => {
  return getStructuredDataSchema({
    webpage: getWebpage({
      description,
      canonicalUrl,
      name: blogLabel,
      image: { name: `${blogLabel} Fallback` },
      hasBreadcrumb: true,
      hasFaqItems: !!faqItems,
      hasHowTo: !!howTo,
    }),
    breadcrumb: getBreadcrumb({ name: blogLabel, canonicalUrl }),
    faq: faqItems ? getFAQ(faqItems, canonicalUrl) : undefined,
    howTo: howTo ? getHowTo({ ...howTo, canonicalUrl }) : undefined,
  })
}
